import { render, staticRenderFns } from "./FormReviewsBanner.vue?vue&type=template&id=607e26b1&scoped=true&"
import script from "./FormReviewsBanner.vue?vue&type=script&lang=js&"
export * from "./FormReviewsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e26b1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default})
